import { Link } from "react-router-dom";
import { Newsletter } from "./Newsletter";
import { IMG } from "@/lib/content";
import { useI18n } from "@/lib/i18n";
import { Reveal } from "@/components/fx/Motion";
import { InstagramLinks, WhatsAppLink } from "./Social";
import { openCookieSettings } from "./CookieBanner";

export const Footer = () => {
  const { t } = useI18n();
  const link = "hover:text-white transition-colors";
  return (
    <footer className="bg-[#080706] border-t border-white/5 overflow-hidden">
      <Newsletter />
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <Reveal className="col-span-2 md:col-span-1">
          <img src={IMG.logo} alt="AJS Luxury" className="h-20 w-20 object-contain mb-4" />
          <p className="text-sm text-white/50 leading-relaxed max-w-xs">{t("footer_about")}</p>
          <InstagramLinks className="mt-5" />
          <WhatsAppLink testId="footer-whatsapp" className="mt-4" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="eyebrow mb-5">{t("footer_shop")}</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link data-testid="footer-shop-all" to="/shop" className={link}>{t("footer_all_products")}</Link></li>
            <li><Link data-testid="footer-primus" to="/collections/primus" className={link}>Primus</Link></li>
            <li><Link data-testid="footer-bellecare" to="/collections/bellecare" className={link}>Bellecare Natural</Link></li>
          </ul>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="eyebrow mb-5">{t("footer_help")}</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link data-testid="footer-shipping" to="/shipping" className={link}>{t("footer_shipping")}</Link></li>
            <li><Link data-testid="footer-returns" to="/returns" className={link}>{t("footer_returns")}</Link></li>
            <li><Link data-testid="footer-privacy" to="/privacy" className={link}>{t("footer_privacy")}</Link></li>
            <li><Link data-testid="footer-cookies" to="/cookies" className={link}>{t("legal_cookies")}</Link></li>
            <li><Link data-testid="footer-terms" to="/terms" className={link}>{t("legal_terms")}</Link></li>
            <li><button data-testid="footer-cookie-settings" onClick={openCookieSettings} className={link}>{t("cookie_settings")}</button></li>
          </ul>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="eyebrow mb-5">{t("nav_journal")}</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link data-testid="footer-blog" to="/blog" className={link}>{t("footer_stories")}</Link></li>
            <li><Link data-testid="footer-about" to="/about" className={link}>{t("footer_about_us")}</Link></li>
            <li><Link data-testid="footer-b2b" to="/b2b" className={link}>{t("footer_b2b")}</Link></li>
          </ul>
        </Reveal>
      </div>
      <div className="border-t border-white/5 py-5 px-5 text-center text-[11px] tracking-[0.2em] uppercase text-white/35">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} AJS Luxury FZCO · {t("footer_secure")}</p>
        <p data-testid="footer-company" className="mt-2 normal-case tracking-[0.08em]">AJS Luxury FZCO · {t("footer_registered")} · {t("footer_licence")} 63259</p>
      </div>
    </footer>
  );
};
